import React, { useEffect, useState } from "react";
import LavorisService from "../../services/LavorisService";
import { useModal } from "../../hooks";
import moment from "moment";
import { useAlert } from "../../hooks/useAlert";
import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { GetOneAbsenceResponseService } from "../../services/Absences/Absences.type";
import AbsenteeismResult from "../others/absenteeismResult";
import { employeeAbsences } from "../Absences/Types/Absences.type";
import { RequestButton } from "../../components/others/RequestTurnButton";
import { getCreatedDateToString } from "../Absences/getCreatedDate";
import { useSelector } from "react-redux";
import { RootState } from "../../store/combineReducer";
import { Badge, BadgeProps } from "@mui/material";
import ChatbotCloseSessionMessage from "../others/chatbotModales/chatbotCloseSessionMessage";
import { TableActions } from "../../components/others/TableActions";
import InfoOffcanvas from '../../components/others/InfoOffCanvas/InfoOffCanvas';
import InfiniteTable from "../../components/others/InfiniteTableComponent/IntiniteTableComponent";
import exelReports from "../Results/exelReports";
import "./absence.scss";

const CLOSE_SESSION_CHATBOT_MESSAGE = "closeSessionChatbotMessage";
const History = () => {
    const reduxStore = useSelector((state: RootState) => state.user);
    const chosenRole: string = reduxStore?.currentRole;
    const controller = new AbortController();
    const signal = controller.signal;
    const today = new Date();
    const formattedToday = today.toISOString().split("T")[0]; // YYYY-MM-DD
    const maxDate = "9999-12-31";
    const [from, setFrom] = useState<string>(formattedToday);
    const [to, setTo] = useState<string>(maxDate);
    const [fromFormatted, setFromFormatted] = useState<string>(moment().format('DD/MM/YYYY'));
    const [toFormatted, setToFormatted] = useState<string>(moment().add(365, 'days').format('DD/MM/YYYY'));
    const [hasMore, setHasMore] = useState(true);
    const [searchQuery, setSearcQuery] = useState<string | null>(null);
    const hasSearchQuery = searchQuery && searchQuery.length > 0
    const LavorisInstance = LavorisService.getInstance();
    const { closeModal, openModal, isActive } = useModal();
    const { showAlert } = useAlert();
    const [items, setItems] = useState({
        itemsPerPage: 40,
        page: 1,
    });

    const [data, setData] = useState<any[]>([]);
    const [loader, setLoader] = useState(false);
    const [selectedEmployee, setSelectedEmployee] = useState<employeeAbsences>();
    const status = 'Cancelado,Completada,Asignada';

    useEffect(() => {
        if (items.page === 1) {
            setData([]);
        }
        return () => {
            controller.abort();
        };
    }, [items.page]);

    const getAllAppointmentsCall = async () => {
        setLoader(true);
        try {
            const app = await LavorisInstance.AbsencesServices.GetAbsencesCompleted(
                //currentCompany, 
                items.itemsPerPage,
                {
                    page: items.page,
                    fromParam: fromFormatted,
                    toParam: toFormatted,
                    searchQuery: hasSearchQuery ? searchQuery : "",
                    status
                },
                signal,
            )


            if (app.absenteesAppointments.length === 0) {
                //showAlert("No se encontraron registros");
                setHasMore(false);
                return;
            }


            // Obtén los IDs de las citas actuales en el estado
            const existingIds = new Set(data?.map(item => item.id));

            // Filtra las nuevas citas para agregar solo las que no están en el estado actual
            const uniqueAppointments = app.absenteesAppointments.filter(appointment => !existingIds.has(appointment.id));

            // Agrega nuevas citas únicas al estado
            setData(prevData => [...prevData, ...uniqueAppointments]);
            //Incrementa la página
            setItems(prev => ({ ...prev, page: prev.page + 1 }));
        } catch (e) {
            console.log(e);
            setHasMore(false);

        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        getAllAppointmentsCall();
        return () => {
            controller.abort()
        };
    }, [])

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const querySearch = e.target.value;
        setSearcQuery(querySearch);
    }

    const searchWithDatesOnly = async () => {
        setLoader(true);
        try {
            setData([]);
            setItems(prev => ({ ...prev, page: 1 }));

            const app = await LavorisInstance.AbsencesServices.GetAbsencesCompleted(
                items.itemsPerPage,
                {
                    page: 1,
                    fromParam: fromFormatted,
                    toParam: toFormatted,
                    searchQuery: "",
                    status
                },
                signal,
            )



            if (app.absenteesAppointments.length === 0) {
                showAlert("No se encontraron registros");
                setData([]);
                return
            } else {
                setData(app.absenteesAppointments);
                setItems(prev => ({ ...prev, page: prev.page + 1 }));
                setHasMore(true);
            }

        } catch (error) {
            console.log(error);
            setHasMore(false);
        } finally {
            setLoader(false);
        }
    }

    const searchWitQuery = async () => {
        setLoader(true);
        try {
            setData([]);
            const app = await LavorisInstance.AbsencesServices.GetAbsencesCompleted(

                items.itemsPerPage,
                {
                    page: 1,
                    fromParam: fromFormatted,
                    toParam: toFormatted,
                    searchQuery: searchQuery,
                    status
                },
                signal,
            )

            if (app.absenteesAppointments.length === 0) {
                showAlert("No se encontraron registros");
                setData([]);
                return
            } else {
                setData(app.absenteesAppointments);
                setItems(prev => ({ ...prev, page: prev.page + 1 }));
                setHasMore(true);
            }

        } catch (error) {
            console.log(error);
            setHasMore(false);
        } finally {
            setLoader(false);
        }
    }

    const onSearch = async () => {
        try {
            if (hasSearchQuery) {
                await searchWitQuery()
            } else {
                await searchWithDatesOnly()
            }

        } catch (error) {
            console.log(error);
        }
    };

    const handleFromDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const dateValue = e.target.value;
        setFrom(dateValue); // Mantiene el valor en formato 'YYYY-MM-DD' para el input
        setFromFormatted(moment(dateValue).format('DD/MM/YYYY')); // Guarda en formato 'DD/MM/YYYY' para procesarlo
    };

    const handleToDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const dateValue = e.target.value;
        setTo(dateValue); // Mantiene el valor en formato 'YYYY-MM-DD' para el input
        setToFormatted(moment(dateValue).format('DD/MM/YYYY')); // Guarda en formato 'DD/MM/YYYY' para procesarlo
    };

    const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: '#f5f5f9',
            color: 'rgba(0, 0, 0, 0.87)',
            maxWidth: 220,
            fontSize: theme.typography.pxToRem(12),
            border: '1px solid #dadde9',
        },
    }));

    const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
        '& .MuiBadge-badge': {
            right: -3,
            top: 13,
            border: `2px solid ${theme.palette.background.paper}`,
            padding: '0 4px',
            margin: '0  4px'
        },
    }));

    const diagnostico = (rowData: GetOneAbsenceResponseService) => {
        let diagnostic = rowData.report.diagnostic;
        if (!diagnostic) return null;
        if (diagnostic === "*NO JUSTIFICADA*") diagnostic = "NO JUSTIFICADA"
        if (diagnostic === "*NO VALIDA*") diagnostic = "NO VALIDA"
        return rowData.report.diagnostic
    }

    const fechaAlta = (rowData: GetOneAbsenceResponseService) => {
        let releaseDate: any = rowData?.report.releaseDate;
        if (
            releaseDate === "*NO JUSTIFICADA*" ||
            releaseDate === "*NO VALIDA*" ||
            releaseDate === "00/00/0000" ||
            releaseDate === null
        ) {
            return "--";
        }

        const isEuropeanDateFormat = /^\d{2}\/\d{2}\/\d{4}$/.test(releaseDate);

        // Si viene en formato ISO
        const isISODate = /^\d{4}-\d{2}-\d{2}T.*Z$/.test(releaseDate);

        if (isEuropeanDateFormat) {
            return moment(releaseDate, "DD/MM/YYYY").format("DD/MM/YYYY");
        } else if (isISODate) {
            return moment(releaseDate).format("DD/MM/YYYY");
        }

        return "--";
    }

    const fechaSolicitud = (rowData: GetOneAbsenceResponseService) => {
        if (!rowData) return 'No disponible'
        let fecha = getCreatedDateToString(rowData?.createdDate)[0];
        return `${fecha}`
    }

    const giaSolicitud = (rowData: GetOneAbsenceResponseService) => {
        if (!rowData) return '---'
        const gia = rowData?.gia ? 'Si' : 'No'
        return (
            <p className={`${rowData.gia ? 'text-green-700' : 'text-red-700'} font-extrabold`}>{gia} </p>
        )
    }


    data.sort((a, b) => {
        const createdDateA = new Date(a.createdDate);
        const createdDateB = new Date(b.createdDate);

        return createdDateB.getTime() - createdDateA.getTime();
    });

    return (
        <div className="absence-module-container">
            <div className="custom-header mt-4 pt-2">
                <div className="header-controls">
                    {/* Search Section */}
                    <div className="search-section">
                        <div className="search-input-group">
                            <div className="search-input-label-top">
                                <label htmlFor="search-dni">Buscar por DNI o Apellido</label>
                                <input
                                    title="Ingresar dni o apellido"
                                    type="search"
                                    placeholder="Ingresa un DNI o Apellido"
                                    className="search-input"
                                    onChange={handleSearchChange}
                                />
                            </div>
                            <div className="search-input-label-top">
                                <label htmlFor="search-date-from">Desde</label>
                                <input
                                    title="Desde"
                                    type="date"
                                    value={from ?? ""}
                                    placeholder="Desde"
                                    className="search-input"
                                    onChange={handleFromDateChange}
                                />
                            </div>
                            <div className="search-input-label-top">
                                <label htmlFor="search-date-to">Hasta</label>
                                <input
                                    title="Hasta"
                                    type="date"
                                    value={to ?? ""}
                                    placeholder="Hasta"
                                    className="search-input"
                                    onChange={handleToDateChange}
                                />
                            </div>
                            <button
                                type="button"
                                className="search-btn"
                                onClick={() => {
                                    onSearch()
                                }}
                                title="Buscar"
                            >
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path
                                        d="M7.333 12.667A5.333 5.333 0 1 0 7.333 2a5.333 5.333 0 0 0 0 10.667ZM14 14l-2.9-2.9"
                                        stroke="currentColor"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </button>
                        </div>
                    </div>

                    {/* Actions Section */}
                    <div className="actions-section">
                        <div className="results-count d-inline-flex">
                            <span className="count-number">{data.length}</span>
                            <span className="count-label">items</span>
                        </div>

                        {!loader && (
                            <>
                                <button
                                    className="download-btn"
                                    onClick={() => exelReports(data, false)}
                                    title="Descargar reporte de todos los postulantes"
                                    disabled={data.length === 0}
                                >
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path
                                            d="M14 10v2.667A1.333 1.333 0 0112.667 14H3.333A1.333 1.333 0 012 12.667V10M8 10.667L8 2M8 10.667l-2.667-2.666M8 10.667l2.667-2.666"
                                            stroke="currentColor"
                                            strokeWidth="1.3"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                    <span className="btn-text">Excel</span>
                                </button>
                            </>
                        )}

                        <InfoOffcanvas title="INFORMACIÓN DE BÚSQUEDA">
                            <ul className="text-md p-auto m-auto">
                                <li>- La primera búsqueda trae todos los resultados del día en adelante.</li>
                                <li>- Se puede búscar solo con fechas.</li>
                                <li>- Si se búsca con apellido, nombre o dni y no se filtra por fecha, trae todo lo del día.</li>
                                <li>- Las fechas del filtro se pueden poner manualmente.</li>
                                <li>- A medida que se va haciendo scroll para abajo, la tabla va buscando más resultados.</li>
                            </ul>
                        </InfoOffcanvas>

                    </div>
                </div>
            </div>

            <InfiniteTable
                data={data}
                loading={loader}
                hasMore={hasMore}
                columns={[
                    {
                        key: 'patientName',
                        title: 'Apellido y Nombre',
                        className: 'col-name',
                        render: (value: any, row: any) =>
                            row?.employee?.name.toUpperCase() || "No disponible"
                    },
                    {
                        key: 'dni',
                        title: 'DNI',
                        className: 'col-dni',
                        render: (value: any, row: any) =>
                            row?.employee?.DNI || "No disponible"
                    },
                    {
                        key: 'fecha',
                        title: 'Fecha de solicitud',
                        className: 'col-fecha-turno',
                        render: (value: any, row: any) =>
                            fechaSolicitud(row) || "No disponible"
                    },
                    {
                        key: 'gia',
                        title: 'AI',
                        className: 'col-gia',
                        render: (value: any, row: any) =>
                            giaSolicitud(row) || "No disponible"
                    },
                    {
                        key: 'type',
                        title: 'Tipo',
                        className: 'col-type',
                        render: (value: any, row: any) =>
                            row?.type === 'Define Lavoris' ? 'AI' : row?.type || ""
                    },
                    {
                        key: 'status',
                        title: 'Estado',
                        className: 'col-status',
                        render: (value: any, row: any) =>
                            row?.status || "No disponible"
                    },
                    {
                        key: 'diagnostic',
                        title: 'Diagnóstico',
                        className: 'col-diagnostic',
                        render: (value: any, row: any) => diagnostico(row)
                    },
                    {
                        key: 'visitManualTime',
                        title: 'Fecha y hora de visita',
                        className: 'col-fecha-turno',
                        render: (value: any, row: any) => row.report.visitManualTime
                    },
                    {
                        key: 'releaseDate',
                        title: 'Fecha de alta',
                        className: 'col-fecha-turno',
                        render: (value: any, row: any) => fechaAlta(row) || "No disponible"
                    },
                    {
                        key: 'actions',
                        title: 'Acciones',
                        className: 'col-actions',
                        render: (value: any, row: any) => (

                            <div className="flex flex-wrap gap-2 justify-center">
                                {
                                    chosenRole !== "RRHH_APPOINTMENTS_AND_ABSENTEE" && (
                                        <TableActions
                                            type="View"
                                            onClick={() => {
                                                setSelectedEmployee(row);
                                                openModal("modalReporteAusentismo", row.id);
                                            }}
                                        />

                                    )
                                }
                                {(row?.gia && !row?.chatbot_session_closed) && (
                                    <TableActions
                                        type="Phone"
                                        title={row?.chatbot_id && row?.chatbot_message_state !== 'closing' ? 'Comenzado' : row?.chatbot_id && row?.chatbot_message_state === 'closing' ? 'Finalizado correctamente' : 'Sin acción'}
                                        color={row?.chatbot_id && row?.chatbot_message_state !== 'closing' ? 'orange' : row?.chatbot_id && row?.chatbot_message_state === 'closing' ? 'green' : ''}
                                        onClick={() => { }}
                                    />
                                )}
                                {(row?.gia && row?.chatbot_session_closed && row?.chatbot_id) && (
                                    <TableActions
                                        type="Cancel Phone"
                                        title="Chatbot cancelado (Ver)"
                                        color="red"
                                        onClick={() => openModal(CLOSE_SESSION_CHATBOT_MESSAGE, row?.id)}
                                    />
                                )}
                            </div>

                        )
                    }
                ]}
                onLoadMore={getAllAppointmentsCall}
            />

            {
                isActive("modalReporteAusentismo") && (
                    <AbsenteeismResult
                        toggleModal
                        urlTittle={"modalReporteAusentismo"}
                        patient={selectedEmployee}
                        onClose={() => closeModal("modalReporteAusentismo")}
                    />
                )
            }

            {
                isActive(CLOSE_SESSION_CHATBOT_MESSAGE) && (
                    <ChatbotCloseSessionMessage
                        show
                        urlTittle={CLOSE_SESSION_CHATBOT_MESSAGE}
                        onClose={() => closeModal(CLOSE_SESSION_CHATBOT_MESSAGE)}
                    />
                )
            }
        </div>
    )
}

export default History